export type CecPlanId = "annual" | "apprentice";

export const DEFAULT_CEC_PLAN: CecPlanId = "annual";

export interface CecPaywallFeature {
  annualIncluded: boolean;
  freeIncluded?: boolean;
  label: string;
}

export function isCecPaidFeatureIncluded(
  feature: CecPaywallFeature,
  plan: CecPlanId,
) {
  return plan === "apprentice" || feature.annualIncluded;
}
